<template>
  <div>
    <div class="SystemNotification">
      <div class="SystemNotification-main">
        <module-title title="">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              @click="handleSendNotificationDialog(2)"
            >
              发送通知
            </el-button>
          </div>
        </module-title>
        <el-form
          ref="searchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
          :rules="searchFormRules"
        >
          <el-form-item label="" prop="type">
            <el-select
              v-model="searchForm.type"
              name="type"
              size="medium"
              class="handle-form-input"
              @change="handleVersion"
            >
              <el-option label="系统版本未更新至今" :value="1" />
              <el-option label="App版本未更新至今" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="beforeDays">
            <el-select
              v-model="searchForm.beforeDays"
              name="beforeDays"
              size="medium"
              class="handle-form-input"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in periodTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备SN号：" prop="deviceNo">
            <el-input
              v-model="searchForm.deviceNo"
              name="deviceNo"
              placeholder="输入设备SN号"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="发送状态：" prop="sendStatus">
            <el-select
              v-model="searchForm.sendStatus"
              name="sendStatus"
              size="medium"
              class="handle-form-input"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in statusArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              @click="resetInput"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="sysNotificationList"
          highlight-current-row
          fit
          style="width: 100%"
          element-loading-text="Loading"
          :cell-class-name="cellcb"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="30" fixed />
          <el-table-column type="index" width="50" align="center" label="序号" fixed />
          <el-table-column label="SN号" prop="deviceNo" align="center" width="190">
            <template slot-scope="scope">
              <span v-if="scope.row.deviceNo" :title="scope.row.deviceNo.length > 50 ? scope.row.deviceNo :'' ">
                {{ scope.row.deviceNo.length > 50 ? scope.row.deviceNo.substr(0,50) + '...' : scope.row.deviceNo }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发送状态" prop="sendStatusName" align="center" />
          <el-table-column label="用户账号" prop="userPhone" align="center" width="120" />
          <el-table-column label="系统版本号" prop="systemVersion" align="center" width="100" />
          <el-table-column label="系统版本更新时间" prop="systemVersionUpgradeDate" align="center" width="150" />
          <el-table-column label="系统最新版本" prop="systemLatestVersionName" align="center" width="100" />
          <el-table-column label="系统最新版本更新时间" prop="systemLatestVersionReleaseDate" align="center" width="150" />
          <el-table-column label="系统版本更新至今（天数）" prop="systemVersionUpgradeDistanceDays" align="center" />
          <el-table-column label="课桌先生App版本" prop="appVersion" align="center" />
          <el-table-column label="App版本更新时间" prop="appVersionUpgradeDate" align="center" width="150" />
          <el-table-column label="App最新版本" prop="appLatestVersionName" align="center" />
          <el-table-column label="App最新版本更新时间" prop="appLatestVersionReleaseDate" align="center" width="150" />
          <el-table-column label="App版本更新至今（天数）" prop="appVersionUpgradeDistanceDays" align="center" />
          <el-table-column label="历史发送通知时间" prop="latestSendDate" align="center" width="150" />
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.sendStatus !== 1"
                type="text"
                size="mini"
                @click="handleSendNotificationDialog(1 , scope.row)"
              >
                发送通知
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
      <!-- 发送通知确认框 -->
      <el-dialog
        v-if="dialogNotificationVisible"
        :close-on-click-modal="false"
        title="发送通知确认"
        :visible.sync="dialogNotificationVisible"
        width="650px"
      >
        <div class="dialogNotification">
          <div class="info">
            发送对象：{{ userPhones.join(",") }}
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="handleClose(1)">
              取消
            </el-button>
            <el-button
              :loading="ajaxLoading"
              type="primary"
              size="medium"
              @click="handleSendNotification"
            >
              {{ ajaxLoading?'Loading':'确定' }}
            </el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 发送失败弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        title="发送通知失败"
        :visible.sync="dialogNotificationFailInfo"
        width="650px"
      >
        <div class="dialogNotification">
          <div class="info">
            发送失败对象：{{ sendFailMobile.join(",") }}
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import {
  getRemindersList, sendReminders
} from '@/api/productOperation/mrDesk/upgradeSMSNotification';
import { validateDeviceSn } from '@/utils/validate';

export default {
  name: '',
  data() {
    return {
      // 搜索表单
      searchForm: {
        deviceNo: '',
        type: 1,
        beforeDays: '',
        sendStatus: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchFormRules: {
        deviceNo: [{ validator: validateDeviceSn, trigger: 'blur' }]
      },
      listLoading: false,
      dialogNotificationVisible: false,
      dialogNotificationFailInfo: false,
      sysNotificationList: [],
      ajaxLoading: false,
      deviceIds: [],
      userPhones: [],
      sendFailMobile: []
    };
  },
  computed: {
    periodTypeList() {
      return [
        {
          code: 30,
          name: '一个月'
        },
        {
          code: 90,
          name: '三个月'
        },
        {
          code: 180,
          name: '半年以上'
        }
      ];
    },
    statusArr() {
      return [
        {
          code: 1, name: '发送成功'
        },
        {
          code: 0, name: '发送失败'
        },
        {
          code: -1, name: '未发送'
        }
      ];
    }
  },
  mounted() {
    this.fetchNotificationList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchNotificationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchNotificationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.searchForm.pageNum = 1;
          this.searchForm.pageSize = 10;
          this.fetchNotificationList();
        }
      });
    },
    // 重置
    resetInput() {
      this.searchForm = { ...this.searchForm, deviceNo: '', beforeDays: '', sendStatus: '', type: 1 };
      this.fetchNotificationList();
    },
    // 获取数据
    fetchNotificationList() {
      this.listLoading = true;
      getRemindersList(this.searchForm)
        .then((res) => {
          this.sysNotificationList = res.data.list;
          this.searchForm.total = res.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.sysNotificationList = [];
          this.searchForm.total = 0;
          this.listLoading = false;
        });
    },
    // 弹窗关闭
    handleClose(type) {
      if (type === 1) {
        this.dialogNotificationVisible = false;
      } else {
        this.dialogNotificationFailInfo = false;
      }
    },
    // 版本切换 时间重置
    handleVersion() {
      this.searchForm.beforeDays = '';
    },
    cellcb(row) {
      if (row.row.sendStatus === 1 && row.columnIndex === 0) {
        return 'myNotificationCell';
      }
    },
    // 多选
    handleSelectionChange(val) {
      this.deviceIds = val.filter((v) => v.sendStatus !== 1).map((item) => item.deviceId);
      this.userPhones = Array.from(new Set(val.filter((v) => v.sendStatus !== 1).map((item) => item.userPhone)));
    },
    // 发送通知弹框
    handleSendNotificationDialog(type, row) {
      if (type === 2 && this.deviceIds.length === 0) return;
      if (type === 1) {
        this.deviceIds = [row.deviceId];
        this.userPhones = [row.userPhone];
      }
      this.dialogNotificationVisible = true;
    },
    // 发送通知
    handleSendNotification() {
      this.ajaxLoading = true;
      sendReminders({ deviceIds: this.deviceIds + '' })
        .then((response) => {
          if (response.code === '0' && !response.errorData) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.fetchNotificationList();
          } else if (response.errorData) {
            this.dialogNotificationFailInfo = true;
            this.sendFailMobile = response.errorData;
          }
          this.dialogNotificationVisible = false;
          this.ajaxLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.SystemNotification {
  .dialogNotification {
    .info {
      margin-bottom: 30px;
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
<style lang="scss">
.SystemNotification {
  .myNotificationCell .el-checkbox__input {
    display: none !important;
  }

}
</style>

